import { render } from "./SliderView.vue?vue&type=template&id=6903030b&scoped=true"
import script from "./SliderView.vue?vue&type=script&lang=js"
export * from "./SliderView.vue?vue&type=script&lang=js"

import "./SliderView.vue?vue&type=style&index=0&id=6903030b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6903030b"]])

export default __exports__